<ng-container *ngIf="termsExists">
  <nb-card>
    <nb-card-header i18n="@@Synonyms">Синонимы</nb-card-header>
    <nb-card-body>
      <div style="margin-bottom: 6px">
        <input i18n-placeholder="@@AddSynonymName" [formControl]="inputFormControl"
               nbInput
               type="text"
               fieldSize="small"
               placeholder="Введите синоним для добавления"
               [nbAutocomplete]="auto"
        />
      </div>

      <nb-autocomplete #auto (selectedChange)="insertTerm($event)" [handleDisplayFn]="viewHandle">
        <nb-option *ngFor="let term of terms$ | async" [value]="term">
          {{ term.header }}
        </nb-option>
      </nb-autocomplete>

      <ng-container *ngIf="model?.terms?.length">
        <nb-tag-list>
          <nb-tag appearance="outline" status="primary" *ngFor="let term of model.terms" (remove)="removeTerm(term)" [removable]="true" [text]="term.header"/>
        </nb-tag-list>
      </ng-container>
    </nb-card-body>
  </nb-card>
</ng-container>
